// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2Bf-R","validationTips":"StatementDescriptor_validationTips__uihEx"};